import axios from 'axios';

// Alertas de obra: usa la misma configuración que el bot de WhatsApp (colección alertConfigs).
// Instancia propia de axios: un 403 de este módulo no tiene que cerrar la sesión.
// En local se puede apuntar a un backend propio con REACT_APP_ALERTAS_API_URL.
const BASE = process.env.REACT_APP_ALERTAS_API_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:8081';

const api = axios.create({ baseURL: `${BASE.replace(/\/$/, '')}/api/alertas` });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authLisualToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const errorMsg = (e) => e?.response?.data?.message || e?.message || 'Algo salió mal';
const d = (p) => p.then((r) => r.data);
const enc = encodeURIComponent;

export const alertasApi = {
  listar: (feedId) => d(api.get(`/${enc(feedId)}`)),
  sumar: (body) => d(api.post('/', body)),
  guardar: (phone, feedId, body) => d(api.put(`/${enc(phone)}/obras/${enc(feedId)}`, body)),
  pausar: (phone, feedId, body) => d(api.patch(`/${enc(phone)}/obras/${enc(feedId)}`, body)),
  quitar: (phone, feedId) => d(api.delete(`/${enc(phone)}/obras/${enc(feedId)}`)),
  // Preferencias de notificación de la empresa (campanita): por número, para todas sus cámaras.
  preferencias: (customerId) => d(api.get(`/cliente/${enc(customerId)}/preferencias`)),
  guardarPreferencias: (customerId, phone, body) => d(api.put(`/cliente/${enc(customerId)}/preferencias/${enc(phone)}`, body)),
  vistaPrevia: (phone, feedId, obra) => d(api.post(`/${enc(phone)}/obras/${enc(feedId)}/preview`, { obra })),
  // Combo "IA de obra" / IA Pro (USD 20/mes por cámara, 30 días gratis; lo activado antes del 25/10/2026 sigue en USD 15). Si el backend todavía no tiene las rutas
  // /combo-ia/* (404), se usan las del adicional viejo de entregas, que devuelven el mismo estado.
  comboEstado: (feedId) => d(api.get(`/combo-ia/estado/${enc(feedId)}`)).catch((e) => (e?.response?.status === 404 ? d(api.get('/addon-entregas/estado', { params: { feedId } })) : Promise.reject(e))),
  comboCheckout: (feedId, returnUrl) => d(api.post('/combo-ia/checkout', { feedId, returnUrl })).catch((e) => (e?.response?.status === 404 ? d(api.post('/addon-entregas/checkout', { feedId, returnUrl })) : Promise.reject(e))),
  // IA Pro sin tarjeta: el cliente acepta que se analice su obra con IA y queda 30 días gratis (avisa por mail a Lisual).
  comboActivar: (feedId, pagina) => d(api.post('/combo-ia/activar', { feedId, pagina, consentimiento: true })),
  // Adicional Seguridad e Higiene (USD 10/mes por cámara, sobre IA Pro, 30 días gratis sin tarjeta con consentimiento).
  seguridadEstado: (feedId) => d(api.get(`/seguridad/estado/${enc(feedId)}`)),
  seguridadActivar: (feedId, pagina) => d(api.post('/seguridad/activar', { feedId, pagina, consentimiento: true })),
  comboPortal: (feedId, returnUrl) => d(api.post('/combo-ia/portal', { feedId, returnUrl })).catch((e) => (e?.response?.status === 404 ? d(api.post('/addon-entregas/portal', { feedId, returnUrl })) : Promise.reject(e))),
  // Adicional "Alertas de entregas" (rutas viejas; el backend nuevo las atiende con el combo)
  entregasEstado: (feedId) => d(api.get('/addon-entregas/estado', { params: { feedId } })),
  entregasCheckout: (feedId, returnUrl) => d(api.post('/addon-entregas/checkout', { feedId, returnUrl })),
  entregasConfirmar: (feedId, sessionId) => d(api.post('/addon-entregas/confirm', { feedId, sessionId })),
  entregasPortal: (feedId, returnUrl) => d(api.post('/addon-entregas/portal', { feedId, returnUrl })),
  entregasCortesia: (feedId, activo) => d(api.post('/addon-entregas/cortesia', { feedId, activo })),
};
